import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Col, Row } from 'antd';

import StatusColumn from '@totem/components/ticketing/details/tasks/kanban/statusColumn';
import { taskStatusToColor } from '@totem/components/ticketing/details/tasks/utilities';

const TaskKanbanBoard = () => {
  return (
    <DndProvider backend={HTML5Backend}>
      <Row gutter={[16, 16]}>
        <Col span={5}>
          <StatusColumn
            status={'PENDING'}
            color={taskStatusToColor('PENDING')}
          />
          <StatusColumn
            status={'REOPENED'}
            color={taskStatusToColor('REOPENED')}
          />
          <StatusColumn
            status={'BLOCKED'}
            color={taskStatusToColor('BLOCKED')}
          />
        </Col>
        <Col span={5}>
          <StatusColumn
            status={'SCHEDULED'}
            color={taskStatusToColor('SCHEDULED')}
          />
          <StatusColumn
            status={'WAITING'}
            color={taskStatusToColor('WAITING')}
          />
          <StatusColumn
            status={'ON HOLD'}
            color={taskStatusToColor('ON HOLD')}
          />
        </Col>
        <Col span={5}>
          <StatusColumn
            status={'IN PROGRESS'}
            color={taskStatusToColor('IN PROGRESS')}
          />
        </Col>
        <Col span={5}>
          <StatusColumn status={'REVIEW'} color={taskStatusToColor('REVIEW')} />
          <StatusColumn
            status={'APPROVED'}
            color={taskStatusToColor('APPROVED')}
          />
          <StatusColumn
            status={'REJECTED'}
            color={taskStatusToColor('REJECTED')}
          />
        </Col>
        <Col span={4}>
          <StatusColumn
            status={'COMPLETED'}
            color={taskStatusToColor('COMPLETED')}
          />
          <StatusColumn
            status={'CANCELED'}
            color={taskStatusToColor('CANCELED')}
          />
        </Col>
      </Row>
    </DndProvider>
  );
};

export default TaskKanbanBoard;
